export function deleteCourseTransformation(courses, id){
    if(courses.length > 1) {
        return courses.map(course => {
            if (course.id !== id) {
                return course;
            }
        })
    }else{
        return []
    }
}

export function deleteSubjectTransformation(courses, id){
    let newCourses;

    let courseIndex, subjectIndex;
    courses.map((course, i) => {
        course.CourseSubject.map((sub, subi) => {
            if(sub.id === id){
                courseIndex = i;
                subjectIndex = subi;
            }
        })
    })
    courses[courseIndex].CourseSubject.splice(subjectIndex, 1);
    return courses;
}

export function approveRequestTransformation(courses, courseUser){
    return courses.map((course, i) => {
        if(course.id == courseUser.courseId){
            return {
                ...course,
                CourseUser: course.CourseUser.map(user => {
                    if(user) {
                        if (user.id === courseUser.id) {
                            return {
                                ...user,
                                status: "approved"
                            }
                        } else {
                            return {...user}
                        }
                    }
                })
            }
        }else{
            return {...course}
        }
    })
}

export function addUserToCourseTransformation(courses, user){
    return courses.map((course, i) => {
      if(course.id == user.courseId){
          return {
              ...course,
              CourseUser: course.CourseUser.concat(user)
          }
      }else{
          return {...course}
      }
    })
}

export function removeCourseUserTransformation(courses, id){
    return courses.map((course, i) => {
        return {
            ...course,
            CourseUser: course.CourseUser.map(user => {
                if(user) {
                    if (user.id != id) {

                        return {...user}
                    }
                }
            })
        }
    })
}

export function getTestsFromCourseTransformation(courses){
    return courses.map(course => {
        if(course.DiagnosticTest) {
            return course.DiagnosticTest;
        }
    })
}


// WEBPACK FOOTER //
// ./src/utils/CourseTransformations.js